<template>
  <div class="ring-loader" :style="loaderStyle" :class="current ? '' : `text-${color}`"></div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 36,
    },
    color: {
      type: String,
      default: "primary",
    },
    current: Boolean,
  },
  computed: {
    loaderStyle() {
      return {
        "--size": `${this.size}px`,
      };
    },
  },
};
</script>

<style scoped>
.ring-loader {
  display: inline-block;
  width: var(--size);
  height: var(--size);
  border: 2px solid currentColor;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
